import firebase from 'firebase/app'


const afterLogin = uid => async (dispatch) => {
  dispatch({ type: 'LOGIN' })

  try {
    const snapshot = await firebase.firestore().collection('permissions').doc(uid).get()

    if (snapshot.exists) {
      const data = snapshot.data()

      if (!data.is_admin) {
        return dispatch({
          pathname: '/',
          type: 'LOGIN_ERROR',
          message: 'Wrong permission',
        })
      }

      const userSnapshot = await firebase.firestore().collection('users').doc(uid).get()
      return dispatch({
        data: userSnapshot.data(),
        type: 'LOGIN_SUCCESS',
      })
    }
  } catch (err) { }

  return dispatch({
    type: 'LOGIN_ERROR',
    message: 'User profile not found',
  })
}

export const onAuthChange = user => (dispatch) => {
  dispatch({
    type: 'AUTH_CHANGED',
    uid: user ? user.uid : null,
    isAnonymous: user && user.isAnonymous,
  })

  if (user && user.uid && !user.isAnonymous) {
    dispatch(afterLogin(user.uid))
  }

  if (!user) {
    dispatch({ type: 'LOGOUT' })
  }
}

export const logout = () => (dispatch) => {
  firebase.auth().signOut()
  dispatch({ type: 'LOGOUT' })
}


export const login = (email, password) => async (dispatch) => {
  dispatch({ type: 'LOGIN' })

  try {
    await firebase.auth().setPersistence(firebase.auth.Auth.Persistence.LOCAL)
    await firebase.auth().signInWithEmailAndPassword(email, password)
  } catch (err) {
    let message = ''

    switch (err.code) {
      case 'auth/user-not-found': message = 'Unable to login : wrong e-mail or password'
        break
      default: message = `Sorry, an error occured (${err.code})`
        break
    }

    dispatch({
      message,
      type: 'LOGIN_ERROR',
    })

    throw err
  }
}
